import { times } from 'lodash-es';
import * as React from 'react';

import { scale130, scale150 } from '@xing-com/tokens';

import { SkeletonPillShape } from '..';
import type { SkeletonContentSwitcherProps } from '..';

import * as Styled from './skeleton-content-switcher.styles';

export const SkeletonContentSwitcher = React.forwardRef<
  HTMLDivElement,
  SkeletonContentSwitcherProps
>(
  (
    { className, amount = 3, size = 'medium', ...props },
    forwardedRef
  ): JSX.Element => {
    const widthMultiplier = 3;
    const sizes = {
      small: scale130,
      medium: scale150,
    };

    return (
      <Styled.Container
        aria-hidden="true"
        className={className}
        data-xds="SkeletonContentSwitcher"
        ref={forwardedRef}
        role="presentation"
        {...props}
      >
        {times(amount, (index) => (
          <SkeletonPillShape
            height={sizes[size]}
            key={index}
            width={`calc(${sizes[size]} * ${widthMultiplier})`}
          />
        ))}
      </Styled.Container>
    );
  }
);

SkeletonContentSwitcher.displayName = 'SkeletonContentSwitcher';
